import I18NUtils from './i18n/I18NUtils';
export default class Config {
    constructor(init) {
        this.locale = I18NUtils.getDefaultLocale();
        Object.assign(this, init);
    }
}
//# sourceMappingURL=Config.js.map